import { css } from "styled-components";
import { colors } from "constants/colors";

export const bookingChangesStyles = css`
  .bookingChanges {
    min-width: 260px;

    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-content: stretch;
    flex: 1;
    color: ${colors.almostBlack};
    margin-top: 35px;
    .bookingOverview {
      font-size: 18px;
      font-weight: 600;
      text-transform: capitalize;
      line-height: 18px;
      margin-bottom: 16px;
      margin-top: 5px;
    }
    .bookingDescription {
      font-size: 14px;
    }
    .bookingNameAndPrice {
      margin-bottom: 3px;
    }
    .bookingOverviewNumber {
      font-size: 16px;
    }
    .bookingOverviewTotal {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      gap: 5px;
      font-size: 16px;
      font-weight: 600;
      margin-top: 8px;

      .bookingOverviewNumber {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .downloadReceipt {
      margin-top: 32px;
      display: flex;
      flex-direction: row;
      align-content: flex-end;
      justify-content: flex-end;
    }

    /* .priceAdd {
      color: ${colors.optionBackground};
    } */

    .priceRemove {
      color: ${colors.red};
    }
    .bookingOverviewLine {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      gap: 5px;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 8px;

      .bookingOverviewDots {
        flex: 1;
        display: flex;
        align-items: flex-start;
        margin: 10px;
        flex-direction: row;
        margin-left: 10px;
        margin-right: 5px;
      }
      .dashedLine {
        width: 100%; /* The width of the line will match the width of the container */
        height: 1px; /* Height of the line */
        background: repeating-linear-gradient(
          to right,
          ${colors.borderGrey2} 0,
          ${colors.borderGrey2} 1px,
          /* Length of the dash */ transparent 2px,
          transparent 4px /* Length of the space */
        );
        border: none; /* Remove any default border if present */
      }

      .dashedLineRed {
        width: 100%; /* The width of the line will match the width of the container */
        height: 1px; /* Height of the line */
        background: repeating-linear-gradient(
          to right,
          ${colors.red} 0,
          ${colors.red} 1px,
          /* Length of the dash */ transparent 2px,
          transparent 4px /* Length of the space */
        );
        border: none; /* Remove any default border if present */
      }
      .bookingOverviewNumber {
        min-width: 65px;
        text-align: right;
      }
    }
    .bookingOverviewLineRed {
      .bookingOverviewTitle {
        color: ${colors.red};
        font-weight: 600;
      }
      .bookingOverviewNumber {
        color: ${colors.red};
        font-weight: 600;
      }
    }
  }
`;
